import { render, staticRenderFns } from "./msdsWarningHardcoding.vue?vue&type=template&id=402b30e6"
import script from "./msdsWarningHardcoding.vue?vue&type=script&lang=js"
export * from "./msdsWarningHardcoding.vue?vue&type=script&lang=js"
import style0 from "./msdsWarningHardcoding.vue?vue&type=style&index=0&id=402b30e6&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402b30e6')) {
      api.createRecord('402b30e6', component.options)
    } else {
      api.reload('402b30e6', component.options)
    }
    module.hot.accept("./msdsWarningHardcoding.vue?vue&type=template&id=402b30e6", function () {
      api.rerender('402b30e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/msds/msdsWarningHardcoding.vue"
export default component.exports